'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/domain/product-item-data'
import { EscrowFees } from '@marketplace-web/domain/escrow-pricing-data'
import { getItemPhotoThumbnail } from '@marketplace-web/domain/item-photo-data'

import ServiceFeeIncludedTitle from '../../../ServiceFeeIncludedTitle'

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
}

const DetailedPriceBreakdown = ({ bundleSummary, isSellerBusiness, selectedItems }: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const firstItem = selectedItems[0]
  const isBundle = selectedItems.length > 1
  const commonProps = {
    itemId: selectedItemIds[0]!,
    isSellerBusiness,
    shouldTrimTitle: true,
    shouldMinimiseTitle: true,
    itemPrice: price,
    serviceFee: buyerProtectionFee,
    totalItemPrice: priceWithBuyerProtectionFee,
  }

  if (!firstItem) {
    return <ServiceFeeIncludedTitle {...commonProps} isDisabled />
  }

  const detailedBreakdownProps = {
    itemTitle: firstItem.title,
    itemPhotoSrc: getItemPhotoThumbnail(firstItem.photos),
  }

  // Passing data from bundle summary instead of fetching from escrow fees endpoint for now.
  // At the moment there is not support for multiple item id fetching for escrow fees
  const detailedBreakdownPropsBundle = {
    ...detailedBreakdownProps,
    itemsCount: selectedItems.length,
    escrowFees: {
      buyerProtection: {
        finalPrice: buyerProtectionFee,
        discount: null,
        type: EscrowFees.BuyerProtection,
        isFee: Number(buyerProtectionFee.amount) > 0,
        originalPrice: buyerProtectionFee,
      },
    },
  }

  return (
    <ServiceFeeIncludedTitle
      {...commonProps}
      detailedBreakdown={isBundle ? detailedBreakdownPropsBundle : detailedBreakdownProps}
      trackUnification
    />
  )
}

export default DetailedPriceBreakdown
